var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManagerCount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6570\u636E\u7EDF\u8BA1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u89C4\\u8303/\\u5207\\u56FE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8861\\u6CF0\\u4FE1\\u4F1A\\u6240\\u89C4\\u83032",
    transform: "translate(-290.000000, -1029.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(110.000000, 684.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6570\\u636E\\u7EDF\\u8BA1",
    transform: "translate(180.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L16,0 L16,16 L0,16 L0,0 Z",
    id: "root.list-(Background)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L16,0 L16,16 L0,16 L0,0 Z",
    id: "\\u77E9\\u5F62",
    opacity: 0.0000999999975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,13 C14.5,13.552285 14.0522842,14 13.5,14 L2.5,14 C1.94771522,14 1.5,13.552285 1.5,13 L1.5,3 C1.5,2.44771525 1.94771525,2 2.5,2 L13.5,2 C14.0522847,2 14.5,2.44771525 14.5,3 L14.5,13 L14.5,13 Z M2.5,3 L2.5,13 L13.5,13 L13.5,3 L2.5,3 Z M4,4.5 L4,5.5 L12,5.5 L12,4.5 L4,4.5 Z M4,7 L4,8 L10,8 L10,7 L4,7 Z",
    id: "root-list",
    fillOpacity: 1,
    fill: "currentColor"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerCount);
export default __webpack_public_path__ + "static/media/manager-count.d415bdb07e6d316e6518c93935a50b56.svg";
export { ForwardRef as ReactComponent };